ready(function () {
  Fancybox.bind("[data-fancybox]", {});
});